var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3039 12.4976C23.3039 18.4636 18.4675 23.3 12.5015 23.3C6.53558 23.3 1.69922 18.4636 1.69922 12.4976C1.69922 6.53168 6.53558 1.69531 12.5015 1.69531C18.4675 1.69531 23.3039 6.53168 23.3039 12.4976Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3245 13.0481H13.301V13.0715V16.7761C13.301 17.0054 13.1023 17.1953 12.8567 17.1953H12.1464C11.9009 17.1953 11.7021 17.0054 11.7021 16.7761V13.0715V13.0481H11.6787H8.2484C8.00284 13.0481 7.80408 12.8582 7.80408 12.6289V11.9568C7.80408 11.7276 8.00284 11.5377 8.2484 11.5377L8.24885 11.5377L11.6791 11.4721L11.7021 11.4717V11.4487V8.21944C11.7021 7.99017 11.9009 7.80029 12.1464 7.80029H12.8567C13.1023 7.80029 13.301 7.99017 13.301 8.21944V11.5143V11.5377H13.3245H16.7547C17.0003 11.5377 17.1991 11.7276 17.1991 11.9568V12.6289C17.1991 12.8582 17.0003 13.0481 16.7547 13.0481H13.3245Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.046875
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.57514056.svg";
export { ForwardRef as ReactComponent };